import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { IconLibrary } from 'libs/gb-dashboard/shared/ui/src/lib/gb-icon/gb-icon-library.models'

@Component({
  selector: 'gb-ai-tips-and-disclaimer',
  templateUrl: './gb-ai-tips-and-disclaimer.component.html',
  styleUrls: ['./gb-ai-tips-and-disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbAiTipsAndDisclaimerComponent {
  @Input() showLogoDisclaimer = false
  @Input() tipsExpanded = true

  IconLibrary = IconLibrary

  toggleTips(): void {
    this.tipsExpanded = !this.tipsExpanded
  }
}
